import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import SessionManager from "./session-manager";

const PrivateRoute = ({ component: Component, ...rest}) => (
  <Route {...rest} render={(props) => (
      SessionManager.getSession() ? <Component {...props} {...rest}/> : <Redirect to='/login'/>
  )}/>
);
export default PrivateRoute;